/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CloseSendItemRequest,
    CreateSendItemRequest,
    CreateSendItemResponse,
} from '../models';

export interface LiveStreamSendItemApiControllerCancelSendItemRequest {
    liveStreamId: string;
    id: string;
    closeSendItemRequest: CloseSendItemRequest;
}

export interface LiveStreamSendItemApiControllerCreateSendItemRequest {
    liveStreamId: string;
    createSendItemRequest: CreateSendItemRequest;
}

export interface LiveStreamSendItemApiControllerRejectSendItemRequest {
    liveStreamId: string;
    id: string;
    closeSendItemRequest: CloseSendItemRequest;
}

/**
 * 
 */
export class LiveStreamSendItemApi extends runtime.BaseAPI {

    /**
     */
    async liveStreamSendItemApiControllerCancelSendItemRaw(requestParameters: LiveStreamSendItemApiControllerCancelSendItemRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamSendItemApiControllerCancelSendItem.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling liveStreamSendItemApiControllerCancelSendItem.');
        }

        if (requestParameters.closeSendItemRequest === null || requestParameters.closeSendItemRequest === undefined) {
            throw new runtime.RequiredError('closeSendItemRequest','Required parameter requestParameters.closeSendItemRequest was null or undefined when calling liveStreamSendItemApiControllerCancelSendItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/send-items/{id}:cancel`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.closeSendItemRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamSendItemApiControllerCancelSendItem(requestParameters: LiveStreamSendItemApiControllerCancelSendItemRequest): Promise<void> {
        await this.liveStreamSendItemApiControllerCancelSendItemRaw(requestParameters);
    }

    /**
     */
    async liveStreamSendItemApiControllerCreateSendItemRaw(requestParameters: LiveStreamSendItemApiControllerCreateSendItemRequest): Promise<runtime.ApiResponse<CreateSendItemResponse>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamSendItemApiControllerCreateSendItem.');
        }

        if (requestParameters.createSendItemRequest === null || requestParameters.createSendItemRequest === undefined) {
            throw new runtime.RequiredError('createSendItemRequest','Required parameter requestParameters.createSendItemRequest was null or undefined when calling liveStreamSendItemApiControllerCreateSendItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/send-items`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createSendItemRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async liveStreamSendItemApiControllerCreateSendItem(requestParameters: LiveStreamSendItemApiControllerCreateSendItemRequest): Promise<CreateSendItemResponse> {
        const response = await this.liveStreamSendItemApiControllerCreateSendItemRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async liveStreamSendItemApiControllerRejectSendItemRaw(requestParameters: LiveStreamSendItemApiControllerRejectSendItemRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamSendItemApiControllerRejectSendItem.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling liveStreamSendItemApiControllerRejectSendItem.');
        }

        if (requestParameters.closeSendItemRequest === null || requestParameters.closeSendItemRequest === undefined) {
            throw new runtime.RequiredError('closeSendItemRequest','Required parameter requestParameters.closeSendItemRequest was null or undefined when calling liveStreamSendItemApiControllerRejectSendItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/send-items/{id}:reject`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.closeSendItemRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamSendItemApiControllerRejectSendItem(requestParameters: LiveStreamSendItemApiControllerRejectSendItemRequest): Promise<void> {
        await this.liveStreamSendItemApiControllerRejectSendItemRaw(requestParameters);
    }

}
